<template>
  <actionbar v-if="btnList && btnList.length > 0">
    <!-- btn-pink btn-cancel-->
    <button
      v-for="(item, index) in btnList"
      :key="'btn_' + index"
      class="btns"
      :class="item.styleClass"
      slot="buttons"
      @click="operation(item.actionType)"
    >
      {{ item.txt }}
    </button>
    <div v-if="countDownShow && countDown" slot="tips" class="countdown">
      {{ countDown }}
    </div>
  </actionbar>
</template>
<script>
import actionbar from '@/components/newOrder/actionbar'
import { Msgbox } from 'kf-component-vue'
import { Indicator } from 'mint-ui'
import { get } from 'lodash'
import { getButtonListNormal } from '../../getButonListNormal'
import {
  E_SKUTAG,
  OrderDetailActionType_ENUM,
  ORDER_STATE_ENUM,
  ORDER_BELONG_BUSI_ENUM
} from '@/config'
import BUS from '@/Bus/order.js'
import { pushNrNs, pushHref } from '@/plugins/jump'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

export default {
  name: 'OrderDetailButtons',
  inject: {
    servTelTrackParams: {
      default: null
    }
  },
  props: ['order', 'groupDetail'],
  data() {
    return {
      countDown: '',
      countDownInterval: null
    }
  },
  computed: {
    btnList() {
      return getButtonListNormal(this.order, this.groupDetail)
    },
    /**
     * 露出倒计时逻辑：
     * 联营月嫂品类  && 订单状态待使用 && 当前时间超过预产期83天小于90天
     * 家电洗护品类  && 订单状态待使用 && 当前时间在服务时间起至服务时间+7天之间
     */
    countDownShow() {
      const oneMinute = 60 * 1000
      const oneHour = 60 * oneMinute
      const oneDay = 24 * oneHour

      const calcCountdown = () => {
        let surplus = autoCompleteTime - nowTime
        if (surplus > 0) {
          const day = Math.floor(surplus / oneDay)
          surplus -= day * oneDay
          const hour = Math.floor(surplus / oneHour)
          surplus -= hour * oneHour
          const minute = Math.floor(surplus / oneMinute)
          surplus -= minute * oneMinute
          this.countDown = `还剩${day}天${hour}时${minute}分自动确认`
        } else {
          this.countDown = ``
          clearInterval(this.countDownInterval)
        }
      }

      this.countDownInterval && clearInterval(this.countDownInterval)
      let nowTime = get(this.order, 'barcodeList[0].nowTime', Date.now()) //服务器当前时间
      const autoCompleteTime = dayjs(
        get(this.order, 'barcodeList[0].overTimeWriteTime'),
        'YYYY-MM-DD HH:mm:ss'
      ).valueOf() //订单自动核销时间
      const confirmCompleteBtnShow = this.btnList.some(
        item =>
          item.actionType == OrderDetailActionType_ENUM.TO_CONFIRM_COMPLETED
      )
      if (
        (E_SKUTAG.POPYUSAO == this.order.skuTag ||
          E_SKUTAG.APPLIANCE_WASHING == this.order.skuTag) && //联营月嫂 或 家电洗护
        confirmCompleteBtnShow &&
        nowTime > autoCompleteTime - 7 * oneDay &&
        nowTime < autoCompleteTime
      ) {
        //7天倒计时
        calcCountdown()
        this.countDownInterval = setInterval(() => {
          nowTime += 1000
          calcCountdown()
        }, 1000)
        return true
      }
      return false
    }
  },
  methods: {
    // showOrangeButton(cType) {
    //     //再来一单、去支付、去使用、确认收货？
    //     return [70,10,20,].indexOf(cType) != -1
    // },
    operation(actionType) {
      switch (actionType) {
        case OrderDetailActionType_ENUM.TO_PAY:
        case OrderDetailActionType_ENUM.TO_PAY_PRE:
        case OrderDetailActionType_ENUM.TO_PAY_REST: {
          this.toPay()
          break
        }
        case OrderDetailActionType_ENUM.TO_CANCEL_ORDER: {
          this.$emit('cancelOrder')
          break
        }
        case OrderDetailActionType_ENUM.TO_CONFIRM_COMPLETED:
        case OrderDetailActionType_ENUM.TO_CONFIRM_RECEIVED: {
          this.$emit('selfUseCode')
          break
        }
        case OrderDetailActionType_ENUM.TO_SERVICE_TEL_NORMAL: {
          location.href = 'tel:4008288686'
          this.servTelTrackParams &&
            this.$$newTrackClick(this.servTelTrackParams)
          break
        }
        case OrderDetailActionType_ENUM.TO_APPLY_REFUND: {
          this.$emit('returnOrder')
          break
        }
        case OrderDetailActionType_ENUM.TO_COMMENT: {
          this.toEvaluate()
          break
        }
        case OrderDetailActionType_ENUM.TO_LOOK_COMMENTS: {
          this.toLookEvaluate()
          break
        }
        case OrderDetailActionType_ENUM.TO_DEL_ORDER: {
          this.deleteOrderMsgBox()
          break
        }
        case OrderDetailActionType_ENUM.TO_RESERVE_DATETIME_TAKE_PHOTO: {
          this.toReserveDateTimeTakePhoto()
          break
        }
        // case OrderDetailActionType_ENUM.TO_MODIFY_DATETIME_TAKE_PHOTO: {
        //         this.toModifyDateTimeTakePhoto()
        //         break
        //     }
        case OrderDetailActionType_ENUM.TO_MY_YUESAO: {
          this.toLinkMyYuesao()
          break
        }
        case OrderDetailActionType_ENUM.TO_SEE_INSURANCE: {
          const { insureStartTime = 0, giveInsure = 1 } = this.order || {}
          if (insureStartTime && giveInsure === 2) {
            this.$$toast(
              `保单暂未生效，请在${dayjs(insureStartTime).format(
                'YYYY年M月D日'
              )}后查看保单`
            )
            return
          } else if (giveInsure === 3) {
            this.$$toast('对不起，保险领取失败，无法查看保单')
            return
          } else if (giveInsure === 4) {
            this.$$toast('投保信息提交中，请稍后查看')
            return
          }
          const uid = this.$$cookie('uid')
          const skey = this.$$cookie('skey')
          if (uid && skey) {
            const url =
              'https://finance.xingbeibaoxian.com/insurance/myOrder?bizCode=kw'
            location.href = `https://finance.xingbeibaoxian.com/xb-passport/login?loginType=1&tCode=kw&uid=${uid}&skey=${skey}&refer=${encodeURIComponent(
              url
            )}`
          }
          break
        }
        default:
          break
      }
    },
    //订单详情 去支付
    toPay() {
      const order = this.order
      let orderId = order.orderId
      if (order.isPayPeriod && order.isPayPeriod == 1 && order.payPeriodInfo) {
        //定金尾款
        const { prePayOrder = {} } = order.payPeriodInfo
        const { endPayOrder = {} } = order.payPeriodInfo
        if (
          prePayOrder.preOrderState &&
          prePayOrder.preOrderState == ORDER_STATE_ENUM.PENDING_PAY
        ) {
          orderId = prePayOrder.preOrderId
        } else if (
          endPayOrder.endOrderState &&
          endPayOrder.endOrderState == ORDER_STATE_ENUM.PENDING_PAY
        ) {
          orderId = endPayOrder.endOrderId
        }
      }
      if (order.isPosPay) {
        location.href = `/v/order/payment/${orderId}?cmd=share&sharetype=0&refresh=no`
      } else {
        let url = ''
        let partnerid =
          ORDER_BELONG_BUSI_ENUM.CZJ == order.businessType ? '3005' : '3004'
        let platformid =
          ORDER_BELONG_BUSI_ENUM.CZJ == order.businessType ? '1' : '2'
        //TODO 兼容携程景区
        if (order.partnerId === '3007') {
          partnerid = '3007'
          platformid = '1'
        }
        if (order.partnerId === '3008') {
          partnerid = '3008'
          platformid = '1'
        }
        let cashierUrl = `${this.$$hostname(
          'cashier'
        )}/query/${orderId}?partnerid=${partnerid}&dealcode=${orderId}&platformid=${platformid}&cmd=share&sharetype=0`

        if (this.$$isHZWApp()) {
          cashierUrl = `${this.$$hostname(
            'cashier'
          )}/query/${orderId}?partnerid=${partnerid}&dealcode=${orderId}&platformid=${platformid}&cmd=khzwcashier`
        }

        url = `${cashierUrl}&uid=${this.$$cookie('uid')}&skey=${this.$$cookie(
          'skey'
        )}`

        location.href = url
      }
    },
    toReserveDateTimeTakePhoto() {
      //TODO businessId & orderId & reserveId
      pushNrNs({
        name: 'add-reserve',
        query: {
          orderId: this.order.orderId,
          businessId: this.order.businessId
        }
      })
    },
    // toModifyDateTimeTakePhoto() {
    //     pushNrNs({
    //         name: 'selfphoto-addorder',
    //         query: {
    //             orderId: this.order.orderId,
    //             businessId: this.order.businessId,
    //             reserveId: this.order?.reserveRecord?.id || ''
    //         },
    //     })
    // },
    cancelOrder() {
      Msgbox({
        title: '取消订单',
        message: '确认取消？',
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        confirmButtonClass: 'comment-confirm',
        type: 'confirm',
        action: msgbox => {
          //TODO 旧版带选项的，没选项,能提交吗
          this.$emit('cancelOrder')
        },
        cancel: msgbox => {}
      })
    },
    toEvaluate() {
      if (ORDER_BELONG_BUSI_ENUM.CZJ == this.order.businessType) {
        //21育儿 20 成长加
        let url = `//m.czj100.com/comment/publish2product?id=${this.order.spuId}&orderId=${this.order.orderId}&cmd=share&sharetype=0&refresh=no`
        //TODO 登录态问题待处理
        if (this.$$isHZWApp() || this.$$isCZJApp()) {
          url = `//app.czj100.com/webridge.html?url=${encodeURIComponent(
            url
          )}&uid=${this.$$cookie('uid')}&skey=${this.$$cookie('skey')}`
        }

        location.href = url
      } else {
        pushNrNs({
          // 新写评价入口
          name: 'evaluate',
          query: {
            orderCode: this.order.orderId,
            ht: 'add'
          }
        })
      }
    },
    toLookEvaluate() {
      if (ORDER_BELONG_BUSI_ENUM.CZJ == this.order.businessType) {
        location.href = `//m.czj100.com/look/${this.order.commentId}`
      } else {
        pushHref({
          // 新查看评价入口
          name: 'evaluate',
          query: {
            commentId: this.order.commentId,
            orderCode: this.order.orderId,
            ht: 'look'
          }
        })
      }
    },
    deleteOrderMsgBox() {
      Msgbox({
        title: '删除订单',
        message: '确认删除？',
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        confirmButtonClass: 'comment-confirm',
        type: 'confirm',
        action: msgbox => {
          this.deleteOrder()
        },
        cancel: msgbox => {}
      })
    },
    async deleteOrder() {
      const { uid, skey } = await this.$$ensureLogin()
      const { orderId } = this.order
      Indicator.open()
      const res = await this.$store.dispatch('deleteOrder', {
        uid,
        skey,
        orderId
      })
      Indicator.close()
      if (+res.code === 1) {
        this.$$toast('删除成功')
        // 更新列表
        BUS.EMIT_E_PASS_INDEX_4_DEL_ITEM(this.index)
        //TODO goback
        // setTimeout(() => {
        //     location.href = `//life.cekid.com/v/user/order?cmd=share&sharetype=0`
        // }, 1000)
        this.$router.go(-1)
      } else if (res.code === '4') {
        this.$$login()
      } else {
        this.$$toast('抱歉，系统异常')
      }
    },
    gotoOrderDetail(order) {
      this.tabText = document.querySelectorAll(
        '.column-list .active'
      )[0].innerText
      // 使用路由跳转方式，用户在订单详情页打开核销码，返回打开另外一个订单并展示核销码会出现二维码重复的bug，原因不明，恢复href跳转方式
      // this.$router.push(
      //   `/order/${
      //     order.orderId
      //   }?cmd=share&sharetype=0&isys=${+isNewAsignedMonthInLaw(this.order)}`,
      // )
      location.href = `/v/order/${
        order.orderId
      }?cmd=share&sharetype=0&isys=${+isNewAsignedMonthInLaw(this.order)}`
    },
    toLinkMyYuesao() {
      location.href = `//life.cekid.com/y/my/yuesao`
    }
  },
  components: {
    actionbar,
    Indicator
  }
}
</script>
<style lang="scss" scoped></style>
